module.exports = __webpack_public_path__ + "img/solarFakeSmall.ceaab975.jpg";